<script setup lang="ts">
import { computed } from 'vue';

const { id, count, maxLength } = defineProps<{
    id: string;
    count: number;
    maxLength: number;
}>();

const overLimit = computed(() => count > maxLength);
</script>

<template>
    <p
        :id="id"
        data-id="character-count"
        class="m-0 shrink-0 text-sm leading-5 tabular-nums transition-opacity duration-150 ease-in-out"
        :class="
            overLimit
                ? 'text-(--state-danger-fg)'
                : 'text-(--text-muted) opacity-0 group-focus-within:opacity-100 group-hover:opacity-100'
        "
    >
        {{ count }}/{{ maxLength }}
    </p>
</template>
